import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import * as Sentry from '@sentry/react';
import App from './App';
import { queryClient } from './packages/api-client/queryClient';
import { ErrorFallback } from './components/ErrorFallback';
import './index.css';

// Initialise Sentry — no-op when DSN is not configured
Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
    environment: import.meta.env.MODE,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
    ],
    // Capture 10 % of transactions for performance monitoring
    tracesSampleRate: 0.1,
    // Capture session replays only when an error occurs
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0.0,
    // Don't initialise if no DSN — prevents console noise in dev
    enabled: !!import.meta.env.VITE_SENTRY_DSN,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary fallback={ErrorFallback} showDialog={false}>
            <QueryClientProvider client={queryClient}>
                <App />
                <Toaster
                    position="top-right"
                    toastOptions={{
                        style: {
                            background: 'var(--surface-raised)',
                            color: 'var(--ink-body)',
                            border: '1px solid var(--border)',
                        },
                    }}
                />
            </QueryClientProvider>
        </Sentry.ErrorBoundary>
    </React.StrictMode>
);
